<template>
  <InfoBranch
    v-if="!!item.config && !!(item.config['tag-oid'] || item.config['tagOid'])"
    :content="item.meta.name"
    :style="{
      marginTop: '2px',
    }"
  />
</template>
<script>
import InfoBranch from '../utils/InfoBranch'
export default {
  name: 'TriggerTagRemoved',
  components: {
    InfoBranch
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  }
}
</script>